import React from "react";
import { put, api, getUser, consts } from "@config";
import Tour, { ReactTourContent } from "@inspinia-react/tour";
import styled from "styled-components";

const user = getUser();
const Wrapper = styled.aside`
  overflow-y: scroll;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
`;

export default props => {
  function onCloseTour() {
    const url = `${api.users.register}${user.id}/`;
    const data = {
      create_branch_tour: true,
      email: user.email,
      timezone: "America/Belem"
    };
    const payload = resp => {
      window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp)); 
    };
    put(url, data, payload);
  }
  return (
    <Tour
      onCloseTour={() => onCloseTour()}
      badgeVerbose
      steps={[
        {
          selector: "container",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Cadastrar seu Negócio"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                Para fazer seu cadastro no <strong>EasyGestor online</strong>,
                basta seguir três passos super simples, que são:
              </p>
              <ul>
                <li>Escolher o tipo de negocio</li>
                <li>Informar dados do contato</li>
                <li>Informar o endereço</li>
              </ul>
              <p>Clique nas setas a seguir</p>
            </ReactTourContent>
          )
        },
        {
          selector: "#person-type",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent
              title="Modalidade"
              goTo={goTo}
              inDOM={inDOM}
              step={step}
            >
              <p>
                Para começar selecione a modalidade que representa a sua empresa
                ou negócio.
              </p>
              <p>
                O <strong>EasyGestor online</strong> fornece suporte tanto para
                pequenas e média empresas, como também para MEI's (Micro
                empreendedor individual)
              </p>
            </ReactTourContent>
          )
        },
        {
          selector: "#branch-info",
          position: [window.screen.width / 5, 20],
          content: ({ goTo, inDOM, step }) => {
            props.nextStep(1);
            return (
              <ReactTourContent
                title="Informações"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Em seguida, forneceça algumas informações necessárias de
                  acordo com o tipo de perfil selecionado.
                </p>
              </ReactTourContent>
            );
          }
        },
        {
          selector: "#address-component",
          content: ({ goTo, inDOM, step }) => {
            props.nextStep(2);
            return (
              <Wrapper>
                <ReactTourContent
                  title="Dados de Endereço"
                  goTo={goTo}
                  inDOM={inDOM}
                  step={step}
                >
                  <p>
                    Agora você só precisa fornecer o endereço da sua empresa.
                    Clique no botão e crie sua primeira filial!
                  </p>
                </ReactTourContent>
              </Wrapper>
            );
          }
        },
        {
          selector: "#set-branch-is-fiscal",
          content: ({ goTo, inDOM, step }) => {
            props.nextStep(3);
            return (
              <Wrapper>
                <ReactTourContent
                  title="Emissão de NF-e e NFC-e"
                  goTo={goTo}
                  inDOM={inDOM}
                  step={step}
                >
                  <p>
                    E por fim, você só poderá selecionar a opção para o envio de
                    NF-e e NFC-e. Agora é só criar sua primeira filial!
                  </p>
                  <button
                    onClick={props.onFinishedTour}
                    className="btn btn-primary btn-block"
                  >
                    Criar!
                  </button>
                </ReactTourContent>
              </Wrapper>
            );
          }
        }
      ]}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/tours/create-branch-tour.jsx